import { getStoredRoles, hasStoredSessionTokens, renewSessionSilently } from './session';

export default async function getRoles() {
    const initialRoles = getStoredRoles();

    if (initialRoles) {
        return initialRoles;
    }

    if (!hasStoredSessionTokens()) {
        return 'error';
    }

    try {
        await renewSessionSilently();
    } catch (error) {
        return 'error';
    }

    const renewedRoles = getStoredRoles();

    return renewedRoles || 'error';
}